import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./searchgrid-widget.html';
import DataRepository from '../../../app/data-framework/data-repository';
import _ from 'lodash';



    function SearchgridWidget(params) {
        var self = this;
        self.params = params;
        self.observableOptions = params.observableOptions;
        self.observableData = params.observableData;
        self.panelTemplate = params.panelTemplate;
        self.widgetSignals = params.widgetSignals;

        self.observableData = params.observableData;

        self.dataRepository = DataRepository.getInstance();
        self.metadata = self.dataRepository.getEndpointsMetadata();

        self.subscriptions = [];

        self.flexQueryOptions = ko.observable({ WhereConditionObj : []});
        self.typeaheadOptions = ko.observable(self.metadata.filterConditions);

        var options = this.observableOptions();
        var savedFilters = options.filter;

        self.statusOptions = self.metadata.statusOptions;
        self.selectedOptions = ko.observableArray();

        if (savedFilters && !_.isEmpty(savedFilters.statuses)) {
            self.selectedOptions(savedFilters.statuses);
        }

        if (savedFilters && !_.isEmpty(savedFilters.search)) {
            self.flexQueryOptions({ WhereConditionObj : [{ conditions: savedFilters.search }] });
        }

        self.multiSelectInitOptions = {
            includeSelectAllOption: true,
            nonSelectedText: "Status: (all)",
            nSelectedPrefix: 'Status: ',
            numberDisplayed: 0,
            maxHeight: 200
        };

        self.subscriptions.push(self.selectedOptions.subscribe(function (newValue) {
            var options = self.observableOptions();

            if (!options.filter) {
                options.filter = {};
            }

            options.filter.statuses = newValue;

            if (self.widgetSignals) {
                self.widgetSignals().dataRequested.dispatch();
            }

            self.observableOptions(options);
        }));

        self.subscriptions.push(self.flexQueryOptions.subscribe(function(newValue) {
            var options = self.observableOptions();

            if (!options.filter) {
                options.filter = {};
            }

            options.filter.search = _.get(newValue, 'WhereConditionObj[0].conditions', []);

            if (self.widgetSignals) {
                self.widgetSignals().dataRequested.dispatch();
            }
            self.observableOptions(options);
        }));

        self.RefreshData();

        self.subscriptions.push(self.observableData.subscribe(function () { self.DataUpdated(); }));
    }

    SearchgridWidget.prototype.RefreshData = function () {};

    SearchgridWidget.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    SearchgridWidget.prototype.OptionsUpdated = function () {
        var self = this;
        self.RefreshData();
    };
    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    SearchgridWidget.prototype.dispose = function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default { viewModel: SearchgridWidget, template: templateMarkup };
